import { FC } from 'react'
import { PrismAsyncLight as SyntaxHighlighterPrism } from 'react-syntax-highlighter'
import { oneLight } from 'react-syntax-highlighter/dist/cjs/styles/prism'
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python'
import tsx from 'react-syntax-highlighter/dist/esm/languages/prism/tsx'

// Register languages you want to support
SyntaxHighlighterPrism.registerLanguage('js', tsx)
SyntaxHighlighterPrism.registerLanguage('jsx', tsx)
SyntaxHighlighterPrism.registerLanguage('ts', tsx)
SyntaxHighlighterPrism.registerLanguage('tsx', tsx)
SyntaxHighlighterPrism.registerLanguage('python', python)

interface SyntaxHighlighterProps {
    children: string
    language: string
    className?: string
}

export const SyntaxHighlighter: FC<SyntaxHighlighterProps> = ({ children, language, className }) => {
    // Create a modified version of oneLight with more contrast
    const enhancedTheme = {
        ...oneLight,
        'code[class*="language-"]': {
            ...oneLight['code[class*="language-"]'],
            color: '#383a42' // Darker text color for better contrast
        },
        'pre[class*="language-"]': {
            ...oneLight['pre[class*="language-"]'],
            backgroundColor: 'transparent'
        },
        '.token.comment': {
            color: '#a0a1a7' // Darker comment color
        },
        '.token.string': {
            color: '#50a14f' // Darker green for strings
        },
        '.token.keyword': {
            color: '#a626a4' // Darker purple for keywords
        },
        '.token.function': {
            color: '#4078f2' // Darker blue for functions
        },
        '.token.number': {
            color: '#986801' // Darker orange for numbers
        },
        '.token.operator': {
            color: '#0184bc' // Darker teal for operators
        },
        '.token.punctuation': {
            color: '#383a42' // Darker text color for punctuation
        }
    }

    return (
        <SyntaxHighlighterPrism
            language={language}
            style={enhancedTheme}
            customStyle={{
                margin: 0,
                width: '100%',
                backgroundColor: 'transparent',
                padding: '1.5rem 1rem', // eslint-disable-line string-to-lingui/missing-lingui-transformation
                fontSize: '0.85rem', // Smaller font size
                position: 'relative',
                zIndex: 2 // Higher z-index to ensure borders are visible
            }}
            codeTagProps={{
                style: {
                    backgroundColor: 'transparent'
                }
            }}
            className={className}
        >
            {children}
        </SyntaxHighlighterPrism>
    )
}
